import { createFileRoute } from '@tanstack/react-router'
import { Contact } from 'lucide-react'
import { z } from 'zod'
import { PeopleScreen } from '@/screens/workspace/SCR-006-people'

export const Route = createFileRoute('/_app/w/$ws/people')({
  staticData: { screen: {"id":"SCR-006","title":"People & perspectives","group":"Workspace","perm":"memory.read","order":6,"description":"What ESM knows about each person, and from whose point of view.", icon: Contact } },
  validateSearch: z.object({ q: z.string().max(100).optional(), p: z.string().max(220).optional() }),
  component: PeopleScreen,
})
